module.exports = __webpack_public_path__ + "static/careCtaIlustrace-75144265128c37e07e6d1c150596b2c9.svg";